/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Interest_CommoditiesInputs */

const en_onboarding_v1_interest_commodities = /** @type {(inputs: Onboarding_V1_Interest_CommoditiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gold or other Commodities`)
};

const de_onboarding_v1_interest_commodities = /** @type {(inputs: Onboarding_V1_Interest_CommoditiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gold oder andere Rohstoffe`)
};

const pt_br2_onboarding_v1_interest_commodities = /** @type {(inputs: Onboarding_V1_Interest_CommoditiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouro ou outras commodities`)
};

const tr_onboarding_v1_interest_commodities = /** @type {(inputs: Onboarding_V1_Interest_CommoditiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altın veya diğer emtialar`)
};

const zh_cn2_onboarding_v1_interest_commodities = /** @type {(inputs: Onboarding_V1_Interest_CommoditiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`黄金或其他大宗商品`)
};

const zh_hk2_onboarding_v1_interest_commodities = /** @type {(inputs: Onboarding_V1_Interest_CommoditiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`黃金或其他商品`)
};

const ko_kr2_onboarding_v1_interest_commodities = /** @type {(inputs: Onboarding_V1_Interest_CommoditiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`금 또는 기타 원자재`)
};

const ru_ru2_onboarding_v1_interest_commodities = /** @type {(inputs: Onboarding_V1_Interest_CommoditiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Золото и другие сырьевые товары`)
};

const es_419_onboarding_v1_interest_commodities = /** @type {(inputs: Onboarding_V1_Interest_CommoditiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oro u otras materias primas`)
};

/**
* | output |
* | --- |
* | "Gold or other Commodities" |
*
* @param {Onboarding_V1_Interest_CommoditiesInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_interest_commodities = /** @type {((inputs?: Onboarding_V1_Interest_CommoditiesInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Interest_CommoditiesInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_interest_commodities(inputs)
	if (locale === "de") return de_onboarding_v1_interest_commodities(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_interest_commodities(inputs)
	if (locale === "tr") return tr_onboarding_v1_interest_commodities(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_interest_commodities(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_interest_commodities(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_interest_commodities(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_interest_commodities(inputs)
	return es_419_onboarding_v1_interest_commodities(inputs)
});